import { gql } from 'apollo-boost';

export const newService2PortfolioMutation = gql`
  mutation newService2portfolioMutation($portfolioId: Int!, $serviceId: Int!) {
    newService2portfolio(portfolioId: $portfolioId, serviceId: $serviceId) {
      success
    }
  }
`;
